<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import Banner from './components/Banner.vue'
import { logicNewsBanner } from '@/logic/news/banner'
import { logicNewsRecommendColumn } from '@/logic/news/column'
import { AD_KEY, type NewsRecommendColumnResponse } from '@/server/types'
import { NEWS_SITE_META } from '@/shared/site'

useSite(NEWS_SITE_META)
const {
  state,
  bannerData,
  getBannerData,
} = logicNewsBanner()

const {
  state: columnState,
  columnData,
  getNewsColumnData,
} = logicNewsRecommendColumn()

function getArticleLsFirstImages(data: NewsRecommendColumnResponse['articleLs']) {
  const item = data?.[0]
  if (!item)
    return []
  return item.coverImgUrls.length > 0 ? item.coverImgUrls : [item.coverImgUrl]
}

await Promise.all([
  getBannerData(),
  getNewsColumnData(),
])
</script>

<template>
  <div class="public-container public-page">
    <UtilLoadState :state="state" :reload-handler="getBannerData">
      <Banner :banner-data="bannerData" mb-xl />
    </UtilLoadState>
    <!-- TODO:B3 -->
    <BaseAd :ad-key="AD_KEY.B3" />

    <div class="flex">
      <div class="flex-grow min-w-205">
        <UtilLoadState :state="columnState" :reload-handler="getNewsColumnData">
          <template v-for="col, i in columnData" :key="i">
            <BasicTitle :title="col.columnName" is-show-after :url="APP_ROUTER.newsClass({ id: col.columnId })" />
            <div class="flex mb-xl mt-sm">
              <div class="flex-shrink-0 h-60.5 w-109 rounded-md overflow-hidden mr-sm bg-slate-1 relative">
                <NCarousel
                  :show-arrow="getArticleLsFirstImages(col.articleLs).length > 1" dot-type="line" effect="fade"
                  :default-index="0" :autoplay="true"
                >
                  <NuxtLink
                    v-for="item, index in getArticleLsFirstImages(col.articleLs)" :key="index"
                    class="flex items-center justify-end h-full relative"
                    :to="APP_ROUTER.newsDetail(col.articleLs[0].articleId)"
                  >
                    <img
                      class="h-full w-full object-cover"
                      :alt="col.articleLs[0].title"
                      :src="imageTransform(item, { width: 975, height: 540, format: 'jpeg' })"
                    >
                  </NuxtLink>
                </NCarousel>
                <h3 class="title">
                  {{ col.articleLs[0].title }}
                </h3>
              </div>

              <div class="flex-grow min-w-0 text-4.125">
                <NuxtLink
                  v-for="(v, i) in col.articleLs.slice(1)" :key="i"
                  :to="APP_ROUTER.newsDetail(v.articleId)"
                  class="block truncate mb-1.5 last:mb-0 hover:text-orange-6 hover:text-orange-6)"
                >
                  {{ v.title }}
                </NuxtLink>
              </div>
            </div>
          </template>
        </UtilLoadState>
      </div>
      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl">
        <RankHotNews class="mb-sm" />
        <RankCctv class="mb-sm" />
        <RankMedia class="sticky top-25" />
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url('@/pages/index/components/banner.scss');
</style>
